<template>
    <v-row v-if="topGenres.length > 0 || topArtists.length > 0 || topTracks.length > 0">
        <v-col cols="12">
          <v-row>
            <v-col cols="1" class="mr-5">
                <h3 class="ma-0 kbSemiDarkBlueText--text" style="font-size: 18px; line-height: 1.2">{{ $t('general.musicalGenres') }}</h3>
                <span class="d-block kbGrayLightText--text"
                      style="cursor:pointer; font-size: 12px"
                      @click="showMusicDialog('genres')">{{ $t('general.seeMore') }}</span>
            </v-col>

            <v-col cols="10" class="py-0">
                <v-chip dark
                        v-for="genre in top10Genres"
                        :key="genre.name"
                        @click="goTo(genre, 'genres')"
                        class="ma-1 kbBlue--text"
                        color="kbBlue"
                        outlined
                        pill>
                    <v-avatar left class="kbBlue white--text">{{genre.count}}</v-avatar>
                    {{genre.name}}
                </v-chip>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-row>
            <v-col cols="1" class="mr-5">
                <h3 class="ma-0 kbSemiDarkBlueText--text" style="font-size: 18px; line-height: 1.2">{{ $t('general.artists') }}</h3>
                <span class="d-block kbGrayLightText--text"
                      style="cursor:pointer; font-size: 12px"
                      @click="showMusicDialog('artists')">{{ $t('general.seeMore') }}</span>
            </v-col>

            <v-col cols="10" class="py-0">
                <v-chip dark
                        v-for="artist in top10Artists"
                        :key="artist.name"
                        @click="goTo(artist, 'artists')"
                        class="ma-1 kbBlue--text"
                        color="kbBlue"
                        outlined
                        pill>
                    <v-avatar left class="kbBlue white--text">{{artist.count}}</v-avatar>
                    {{artist.name}}
                </v-chip>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <v-row>
            <v-col cols="1" class="mr-5">
                <h3 class="ma-0 kbSemiDarkBlueText--text" style="font-size: 18px; line-height: 1.2">{{ $t('general.songs') }}</h3>
                <span class="d-block kbGrayLightText--text"
                      style="cursor:pointer; font-size: 12px"
                      @click="showMusicDialog('tracks')">{{ $t('general.seeMore') }}</span>
            </v-col>

            <v-col cols="10" class="py-0">
                <v-chip dark
                        v-for="track in top10Tracks"
                        :key="track.name"
                        @click="goTo(track, 'tracks')"
                        class="ma-1 kbBlue--text"
                        color="kbBlue"
                        outlined
                        pill>
                    <v-avatar left class="kbBlue white--text">{{track.count}}</v-avatar>
                    <strong>{{track.name}}</strong>
                    <span v-html="' - '" style="margin: 0 5px;"/>
                    <template v-if="Array.isArray(track.artists) && track.artists.length > 0">
                      {{track.artists[0].name}}
                    </template>
                </v-chip>
            </v-col>
          </v-row>
        </v-col>

        <v-dialog @input="closeMusicDialog('genres')" v-model="isMusicGenresDialogShown">
            <v-card color="kbLight">
                <v-card-title>
                    <h3 class="kbDarkBlueText--text">{{ $t('general.topMusicalGenres') }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeMusicDialog('genres')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="searchGenre"
                                          color="kbDarkBlueText"
                                          :label="`${$t('general.search')}...`"
                                          @input="filterLiking('genres')"
                                          placeholder="Tech"
                                          autofocus
                                          clearable
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-chip v-for="genre in resultFilteredTopGenres"
                                    :key="genre.name"
                                    @click="goTo(genre, 'genres')"
                                    class="ma-1"
                                    pill
                                    color="kbBlue"
                                    outlined
                            >
                                <v-avatar left class="kbBlue white--text">{{genre.count}}</v-avatar>
                                {{genre.name}}
                            </v-chip>

                            <v-chip v-if="searchGenre ? limitGenres < filteredTopGenres.length : limitGenres < topGenres.length"
                                    @click="limitGenres += 30"
                                    color="kbDarkText" outlined
                              >
                                <v-icon small>keyboard_arrow_right</v-icon>
                                {{searchGenre ? filteredTopGenres.length - limitGenres : topGenres.length - limitGenres}} {{ $t('general.additionalGenres') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog @input="closeMusicDialog('artists')" v-model="isMusicArtistsDialogShown">
            <v-card color="kbLight">
                <v-card-title>
                    <h3 class="kbDarkBlueText--text">{{ $t('general.topArtists') }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeMusicDialog('artists')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="searchArtist"
                                          color="kbDarkBlueText"
                                          :label="`${$t('general.search')}...`"
                                          @input="filterLiking('artists')"
                                          placeholder="martin ikin"
                                          autofocus
                                          clearable
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-chip v-for="artist in resultFilteredTopArtists"
                                    :key="artist.name"
                                    @click="goTo(artist, 'artists')"
                                    class="ma-1"
                                    pill
                                    color="kbBlue"
                                    outlined
                            >
                                <v-avatar left class="kbBlue white--text">{{artist.count}}</v-avatar>
                                {{artist.name}}
                            </v-chip>

                            <v-chip v-if="searchArtist ? limitArtists < filteredTopArtists.length : limitArtists < topArtists.length"
                                    @click="limitArtists += 30"
                                    color="kbDarkText" outlined
                              >
                                <v-icon small>keyboard_arrow_right</v-icon>
                                {{searchArtist ? filteredTopArtists.length - limitArtists : topArtists.length - limitArtists}} {{ $t('general.additionalArtists') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog @input="closeMusicDialog('tracks')" v-model="isMusicTracksDialogShown">
            <v-card color="kbLight">
                <v-card-title>
                    <h3 class="kbDarkBlueText--text">{{ $t('general.topSongs') }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeMusicDialog('tracks')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="searchTrack"
                                          color="kbDarkBlueText"
                                          :label="`${$t('general.search')}...`"
                                          @input="filterLiking('tracks')"
                                          placeholder="Losing it"
                                          autofocus
                                          clearable
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-chip v-for="track in resultFilteredTopTracks"
                                    :key="track.name"
                                    @click="goTo(track, 'tracks')"
                                    class="ma-1"
                                    pill
                                    color="kbBlue"
                                    outlined
                            >
                                <v-avatar left class="kbBlue white--text">{{track.count}}</v-avatar>
                                <strong>{{track.name}}</strong>
                                <span v-html="' - '" style="margin: 0 5px;"/>
                                <template v-if="Array.isArray(track.artists) && track.artists.length > 0">
                                  {{track.artists[0].name}}
                                </template>
                            </v-chip>

                            <v-chip v-if="searchTrack ? limitTracks < filteredTopTracks.length : limitTracks < topTracks.length"
                                    @click="limitTracks += 30"
                                    color="kbDarkText" outlined
                              >
                                <v-icon small>keyboard_arrow_right</v-icon>
                                {{searchTrack ? filteredTopTracks.length - limitTracks : topTracks.length - limitTracks}} {{ $t('general.additionalSongs') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      advancedSearch: state => state.users.advancedSearch,
      selectedApp: state => state.apps.selectedApp,
      topGenres: state => state.apps.spotifyUsersTopGenres,
      topArtists: state => state.apps.spotifyUsersTopArtists,
      topTracks: state => state.apps.spotifyUsersTopTracks
    }),
    resultFilteredTopGenres () {
      if (this.searchGenre) return this.filteredTopGenres.slice(0, this.limitGenres)
      return this.topGenres.slice(0, this.limitGenres)
    },
    resultFilteredTopArtists () {
      if (this.searchArtist) return this.filteredTopArtists.slice(0, this.limitArtists)
      return this.topArtists.slice(0, this.limitArtists)
    },
    resultFilteredTopTracks () {
      if (this.searchTrack) return this.filteredTopTracks.slice(0, this.limitTracks)
      return this.topTracks.slice(0, this.limitTracks)
    },
    top10Genres () {
      return this.topGenres.slice(0, 10)
    },
    top10Artists () {
      return this.topArtists.slice(0, 10)
    },
    top10Tracks () {
      return this.topTracks.slice(0, 10)
    }
  },
  created () {
    if (this.selectedApp.UUID) {
      this.$store.dispatch('getUsersSpotifyTopGenres')
      this.$store.dispatch('getUsersSpotifyTopArtists')
      this.$store.dispatch('getUsersSpotifyTopTracks')
    }
  },
  data () {
    return {
      isMusicGenresDialogShown: false,
      isMusicArtistsDialogShown: false,
      isMusicTracksDialogShown: false,
      limitGenres: 30,
      limitArtists: 30,
      limitTracks: 30,
      filteredTopGenres: [],
      filteredTopArtists: [],
      filteredTopTracks: [],
      searchGenre: '',
      searchArtist: '',
      searchTrack: ''
    }
  },
  watch: {
    'selectedApp.UUID' (value) {
      this.$store.dispatch('getUsersSpotifyTopGenres')
      this.$store.dispatch('getUsersSpotifyTopArtists')
      this.$store.dispatch('getUsersSpotifyTopTracks')
    }
  },
  methods: {
    closeMusicDialog (likingType = '') {
      if (likingType === 'genres') {
        this.isMusicGenresDialogShown = false
      }
      if (likingType === 'artists') {
        this.isMusicArtistsDialogShown = false
      }
      if (likingType === 'tracks') {
        this.isMusicTracksDialogShown = false
      }
    },
    filterLiking (likingType = '') {
      if (likingType === 'genres') {
        this.limitGenres = 30
        const search = (this.searchGenre || '').toLowerCase()
        this.filteredTopGenres = this.topGenres.filter(like => {
          const name = like.name.toLowerCase()
          return name.indexOf(search) > -1
        })
      }
      if (likingType === 'artists') {
        this.limitArtists = 30
        const search = (this.searchArtist || '').toLowerCase()
        this.filteredTopArtists = this.topArtists.filter(like => {
          const name = like.name.toLowerCase()
          return name.indexOf(search) > -1
        })
      }
      if (likingType === 'tracks') {
        this.limitTracks = 30
        const search = (this.searchTrack || '').toLowerCase()
        this.filteredTopTracks = this.topTracks.filter(track => {
          const name = track.name.toLowerCase()
          let artist
          if (Array.isArray(track.artists) && track.artists.length > 0) {
            artist = track.artists[0].name.toLowerCase()
          }

          return name.indexOf(search) > -1 || (artist && artist.indexOf(search) > -1)
        })
      }
    },
    goTo (like, likingType = '') {
      const query = {}
      if (likingType === 'genres') {
        query.spotifyGenres = like.name
      }
      if (likingType === 'artists') {
        query.spotifyArtists = like.name
      }
      if (likingType === 'tracks') {
        query.spotifyTracks = like.name
      }
      this.$router.push({ name: 'PeopleDirectory', params: { appid: this.$store.getters.appUuid }, query })
    },
    showMusicDialog (likingType = '') {
      if (likingType === 'genres') {
        this.isMusicGenresDialogShown = true
      }
      if (likingType === 'artists') {
        this.isMusicArtistsDialogShown = true
      }
      if (likingType === 'tracks') {
        this.isMusicTracksDialogShown = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
>>> .v-chip__content {
  cursor: pointer !important;
}
</style>
